export default {"src":"/_next/static/media/Ansible.1c2137d1.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};